const { stats } = require('@fiverr-private/obs');
const { STATS_PREFIX, DATA_SIZE } = require('./constants');

/**
 * Prefixed wrapper for the OBS stats.time function
 * @param {String} metric - The metric name
 * @param {Number} value - The value (in ms) to measure
 * @param {Object} options
 * @param {Number} options.rate - Sample rate represented by decimal point fraction [0-1]
 * @return {void}
 */
const time = (metric, value, options = {}) => stats.time(STATS_PREFIX, metric, value, options);

/**
 * Prefixed wrapper for the OBS stats.count function
 * @param {String} metric - The metric name
 * @param {Number} [value = 1] - The increment value (defaults to 1)
 * @param {Object} options
 * @param {Number} options.rate - Sample rate represented by decimal point fraction [0-1]
 * @return {void}
 */
const count = (metric, value = 1, options = {}) => stats.count(STATS_PREFIX, metric, value, options);

/**
 * Size monitoring that calls time
 * @param {String} metric - The metric name
 * @param {Object | String} data - The data to measure
 * @param {Object} options
 * @param {Number} options.rate - Sample rate represented by decimal point fraction [0-1]
 * @return {void}
 */
const dataSize = (metric, data = '', options = {}) => {
    const dataString = (typeof data === 'string') ? data : JSON.stringify(data);

    time(`${DATA_SIZE}.${metric}`, dataString.length, options);
};

module.exports = {
    time,
    count,
    dataSize
};
